import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;
const sampleRate = Number.parseFloat(
  process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0',
);

if (dsn) {
  Sentry.init({
    dsn,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    sendDefaultPii: false,
    tracesSampleRate: Number.isFinite(sampleRate) ? sampleRate : 0,
  });
}
